import {ConfirmSignUp} from "aws-amplify-react";
import {Auth} from "aws-amplify";
import React from "react";
import {ConfirmSignUpComponent} from "../Components/ConfirmSignUpComponents";
import TranslateError from "../translate/TranslateError";
import {STYLE_DISABLE_LINK, STYLE_LINK} from "../Styles/style";
import SimpleReactValidator from "simple-react-validator";
import {err_logger} from "../Logics/logger";

export default class MyConfirmSignUp extends ConfirmSignUp {
    constructor() {
        super();
        this.state = {
            isResendCodeDisable : false,
            isConfirmSignUpDisable : false,
            resendCodeStyle : STYLE_LINK,
            code: "",
            isSetQueryParam: false,
        }
        this.handleInputChangeCustom = this.handleInputChangeCustom.bind(this);
        this.validator = new SimpleReactValidator(
            {
                className: 'text-danger',
                messages: {
                    required: "上記のメールアドレスに送られている数字6桁の認証コードを入力してください ",
                    integer: '上記のメールアドレスに送られている数字6桁の認証コードを入力してください ',
                    between: '上記のメールアドレスに送られている数字6桁の認証コードを入力してください ',
                },
            }
        );
    }
    componentDidUpdate(prevProps) {
        if (prevProps.authState === "signUp" && this.props.authData && this.props.authData.isInitialMessage) {
            this.display_err("入力したメールアドレス宛に必要な認証コードをお送りしました。確認のため御入力お願いします")
        } else if (prevProps.authState === "signIn" && this.props.authData  && this.props.authData.isInitialMessage){
            this.display_err("認証コードの期限が切れていますので、コードの再送信をお願いします")
        }
        if (this.props.authData && this.props.authData.code && !this.state.isSetQueryParam) {
            this.setState({
                code : this.props.authData.code,
                isSetQueryParam: true
            });
        }
    }
    handleInputChangeCustom (e) {
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    validate() {
        let err  = false;
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            err  = true;
            this.forceUpdate();
        }
        return err;
    }
    confirm() {
        const err = this.validate();
        if (err) {
            this.display_err("入力誤りがあります。");
            return;
        }

        this.setState({
            isResendCodeDisable: true,
            isConfirmSignUpDisable: true,
            resendCodeStyle : STYLE_DISABLE_LINK
        });
        const username = this.usernameFromAuthData() || this.inputs.username;
        const { code } = this.state;
        if (!Auth || typeof Auth.confirmSignUp !== 'function') {
            this.setState({
                isResendCodeDisable: false,
                isConfirmSignUpDisable: false,
                resendCodeStyle : STYLE_LINK
            });
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }

        Auth.confirmSignUp(username, code)
            .then(() => {
                this.setState({
                    isResendCodeDisable: false,
                    isConfirmSignUpDisable: false,
                    resendCodeStyle : STYLE_LINK
                });
                window.history.replaceState('','','/');
                // 更新成功画面を表示
                this.changeState('CompConfirmSignUp');

            })
            .catch(err => {
                err_logger(username, err, "confirmSignUp",{username, code});
                this.setState({
                    isResendCodeDisable: false,
                    isConfirmSignUpDisable: false,
                    resendCodeStyle : STYLE_LINK
                });
                this.error(TranslateError(err))
            });
    }
    resend() {
        this.setState({
            isResendCodeDisable: true,
            isConfirmSignUpDisable: true,
            resendCodeStyle : STYLE_DISABLE_LINK
        });

        const username = this.usernameFromAuthData() || this.inputs.username;
        if (!Auth || typeof Auth.resendSignUp !== 'function') {
            this.setState({
                isResendCodeDisable: false,
                isConfirmSignUpDisable: false,
                resendCodeStyle : STYLE_LINK
            });
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.resendSignUp(username)
            .then(() => this.display_err("コードを再送信しました"))
            .catch((err) => {
                err_logger(username, err, "resendSignUp in confirmSignUp",{username});
                this.display_err("コードの再送信に失敗しました")
            })
            .finally(() => {
                this.setState({
                    isResendCodeDisable: false,
                    isConfirmSignUpDisable: false,
                    resendCodeStyle : STYLE_LINK
                });
            });
    }
    display_err(err, translate = false) {
        window.scrollTo(0, 0);
        if (translate) {
            this.error(TranslateError(err))
        } else {
            this.error(err);
        }
    }
    showComponent(theme) {
        const username = this.usernameFromAuthData();
        return (
            <ConfirmSignUpComponent theme={theme} myConfirmSignUp={this} username={username} confirm={this.confirm}
                                    code={this.state.code}
                                    handleInputChangeCustom={this.handleInputChangeCustom}
                                    isResendCodeDisable={this.state.isResendCodeDisable}
                                    isConfirmSignUpDisable={this.state.isConfirmSignUpDisable}
                                    resendCodeStyle={this.state.resendCodeStyle}
                                    code_err_msg={this.validator.message('code', this.state.code, 'required|integer|between:6,6')}
                                    mode={this.props.authData.mode}
                                    changeStateFunc={() => {
                                        window.history.replaceState('','','/');
                                        this.changeState('signIn')
                                    }}/>
        );
    }
}